import React from 'react'
import { cn } from 'components/UI/cn'
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from 'components/UI/BaseDropdown/dropdown-base'
import { EmailAction } from './emailActions'

interface EmailActionMenuItemsProps {
  actions: EmailAction[]
}

/**
 * Renders a list of EmailAction items inside a DropdownMenuContent.
 * Handles regular items, disabled items, and submenu items (e.g. "Assign to deal").
 */
export function EmailActionMenuItems({ actions }: EmailActionMenuItemsProps) {
  return (
    <>
      {actions.map((action, index) => (
        <React.Fragment key={index}>
          {action.subContent && !action.disabled ? (
            <DropdownMenuSub>
              <DropdownMenuSubTrigger
                className={cn('flex items-center gap-2 cursor-pointer')}
              >
                <action.icon className="size-4 flex-shrink-0 text-fg-secondary" />
                <span>{action.label}</span>
              </DropdownMenuSubTrigger>
              <DropdownMenuSubContent className="p-0 bg-surface border-line-focus">
                {action.subContent}
              </DropdownMenuSubContent>
            </DropdownMenuSub>
          ) : (
            <DropdownMenuItem
              disabled={action.disabled}
              onSelect={action.disabled ? undefined : action.onClick}
              className={cn(
                'flex items-center gap-2',
                action.disabled
                  ? 'opacity-50 cursor-not-allowed'
                  : 'cursor-pointer'
              )}
            >
              <action.icon className="size-4 flex-shrink-0 text-fg-secondary" />
              <span>{action.label}</span>
            </DropdownMenuItem>
          )}
          {action.hasSeparatorAfter && <DropdownMenuSeparator />}
        </React.Fragment>
      ))}
    </>
  )
}
